import React, { useState } from "react";
import loader from "../../images/ajax-loader.gif";
import { getVendorByAccount, updateVendorAccountDetail } from "../../api/User";

const UpdateVendorDetails = ({token, userDetail, userData}) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]) 
  const [oldAccountNo, setOldAccountNo] = useState("")
  const [accountNo, setAccountNo] = useState(tableData?.account_number)
  const [ifsc, setIFSC] = useState(tableData?.ifsc)
  const [branchName, setBranchName] = useState(tableData?.branch_name)
  const [bankName, setBankName] = useState(tableData?.bank_name)

  const handleAccountNo = (e) => {
    setLoading(true);
    e.preventDefault()
    setOldAccountNo(e.target.value)
    const data = {
        vendor_code : e.target.value
    }
    getVendorByAccount(token,data)
    .then((res) => {
        if (res.status === "success") {
          setTableData(res?.data[0]);
        } else {
          console.error("Failed to get payment details:", res.error);
        }
      })
      .catch((err) => {
        console.error("Error fetching payment details:", err);
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
  }

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault()
    const data = {
        old_account_no : oldAccountNo,
        new_account_no : accountNo,
        ifsc : ifsc,
        maker_name : userDetail.user_id,
        vendor_id : tableData.vendor_id,
        branch_name : branchName,
        bank_name : bankName,
        created_by : "",
        updated_by : ""
    }
    updateVendorAccountDetail(token,data)
    .then((res) => {
        if (res.status === "success") {
            console.log(res.message)
        } else {
          console.error("Failed to update account detail", res.error);
        }
      })
      .catch((err) => {
        console.error(err);
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
  }
  return (
    <>
      <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <div className="container-fluid col px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5>
            <strong>Update Vendor Account Details</strong>
          </h5>
        </div>
        <form className="filter" id="myform">
          <div className="row mb-4">
            <div className="col-4">
              <label htmlFor="vendor_account" className="form-label">
                Enter Account Number of Vendor {<span style={{ color: "red" }}>*</span>}{" "}
              </label>
              <input type="number" name="vendor_account" className="form-control" onBlur={(e) => handleAccountNo(e)}/>
            </div>
          </div>
        </form>
        <form className="filter mb-5" id="myform">
              <div className="col align-items-center">
                <div className="col-md-12 mt-2">
                  <div className="row">
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        Vendor Name {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="vendor_name"
                        className="form-control"
                        value={tableData?.vendor_name}
                        disabled
                      />
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        Mobile no. {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="number"
                        name="mobile_number"
                        className="form-control"
                        maxLength="10"
                        value={tableData?.mobile_number}
                        disabled
                      />
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        PFMS Id {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="pfms_id"
                        className="form-control"
                        maxLength="12"
                        value={tableData?.pfms_id}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-4">
                  <div className="row">
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        Bank Name {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="vendor_name"
                        className="form-control"
                        value={bankName}
                        placeholder={tableData.bank_name}
                        onChange={(e)=>setBankName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        IFSC Code {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="number"
                        name="mobile_number"
                        className="form-control"
                        value={ifsc}
                        placeholder={tableData.ifsc}
                        onChange={(e)=>setIFSC(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label">
                        Branch Name {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="pfms_id"
                        className="form-control"
                        maxLength="12"
                        value={branchName}
                        placeholder={tableData.branch_name}
                        onChange={(e)=>setBranchName(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-4">
                  <div className="row">
                    <div className="col-md-2 mt-2 d-flex align-items-center">
                      <label className="form-label align-items-center">
                        Account Number {<span style={{ color: "red" }}>*</span>}
                      </label>
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        name="vendor_name"
                        className="form-control"
                        value={accountNo}
                        placeholder={tableData.account_number}
                        onChange={(e)=>setAccountNo(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row col-12 mt-5 d-flex mx-1 mb-5 justify-content-end">
                <button
                  type="submit"
                  className="btn me-2 col-md-2"
                  onClick={handleSubmit}
                >
                  Save
                </button>
                <button type="reset" className="btn me-2 col-md-2">
                  Cancel
                </button>
              </div>
            </form>
      </div>
    </>
  );
};

export default UpdateVendorDetails;
